import { Grid } from '@mui/material';
import ActionButton from 'components/buttons/index';
import { IAudienceSelectionDialogFooter } from './types';

export const AudienceSelectionDialogFooter = ({
  doneDisabled,
  cancelDisabled,
  onCancelSelection,
  onSaveSelection,
}: IAudienceSelectionDialogFooter) => {
  return (
    <Grid container justifyContent="flex-end" sx={{ gap: '12px', marginTop: '20px' }}>
      <ActionButton
        type="button"
        variant="secondary"
        label="Cancel"
        onClick={onCancelSelection}
        disabled={cancelDisabled}
      />
      <ActionButton
        type="button"
        variant="primary"
        label="Done"
        onClick={onSaveSelection}
        disabled={doneDisabled}
      />
    </Grid>
  );
};
